import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import zoomout from "../../assets/images/zoomOut.svg";
import zoomIn from "../../assets/images/zoomIn.svg";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "./Policy.css";

import Modal from "../Modal/Modal";

import { useConstants } from "../../constant/constantProvider";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

const Policy = ({
  handleOnclickSubmit,
  open,
  onClose,
  pdfFile,
  heading,
  isPolicyFirst,
}) => {
  const [checked, setChecked] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [zoom, setZoom] = useState(1.0); // default zoom
  const [scrolledToBottom, setScrolledToBottom] = useState(false);

  const modalRef = useRef(null);
  const scrollRef = useRef(null);

  const { PLEASE_SCROLL_TO_BOTTOM_NOTE } = useConstants();

  useEffect(() => {
    setNumPages(null);
  }, [pdfFile]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3));
  const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.5));

  useEffect(() => {
    if (open) {
      setZoom(1.0);
      setScrolledToBottom(false);
      setChecked(false);
      document.body.classList.add("policy-open");
    } else {
      document.body.classList.remove("policy-open");
    }
    return () => {
      document.body.classList.remove("policy-open");
    };
  }, [open]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open, onClose]);

  // Detect scroll-to-bottom inside PDF wrapper
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setScrolledToBottom(true);
    }
  };

  // Button should be enabled only if:
  // - If policy is first → must scroll to bottom + check the checkbox
  // - If not first → just scroll to bottom
  const isButtonEnabled = isPolicyFirst
    ? scrolledToBottom && checked
    : true;

  return (
    <Modal open={open} onClose={onClose}>
      <div className="policy-modal-overlay">
        <div className="policy-modal-content" ref={modalRef}>
          <div className="policy-modal-header">
            <div className="heading-title">{heading}</div>
            <div className="zoom-buttons">
              <button onClick={handleZoomOut} className="zoom-btn">
                <img src={zoomout} alt="zoom-out" />
              </button>
              <button onClick={handleZoomIn} className="zoom-btn">
                <img src={zoomIn} alt="zoom-in" />
              </button>
            </div>
          </div>

          <div
            className="pdf-scrollable-wrapper"
            ref={scrollRef}
            onScroll={handleScroll}
          >
            <div className="pdf-viewer-container">
              {pdfFile ? (
                <Document
                  file={pdfFile}
                  onLoadSuccess={onDocumentLoadSuccess}
                  loading={<p>Loading PDF...</p>}
                  error={<p>Failed to load PDF.</p>}
                >
                  {Array.from(new Array(numPages), (_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      scale={zoom}
                      width={Math.min(window.innerWidth - 40, 650)}
                    />
                  ))}
                </Document>
              ) : (
                <p>No PDF to display</p>
              )}
            </div>
          </div>

          <div className="policy-footer">
            {isPolicyFirst && (
              <label className="policy-checkbox-label">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                  className="policy-checkbox"
                />
                <span>I have read and agree to the policy</span>
              </label>
            )}
            <div className="button-container">
              <button
                disabled={!isButtonEnabled}
                onClick={handleOnclickSubmit}
                className={`button-style primary-button policy-button ${isButtonEnabled ? "" : "disabled-button"}`}
              >
                {isPolicyFirst ? "Accept & Continue" : "Close"}
              </button>
            </div>
            {isPolicyFirst && (
              <div className="policy-note-text">
                {PLEASE_SCROLL_TO_BOTTOM_NOTE}
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Policy;